import React from "react";
import { FiActivity, FiUsers, FiSettings, FiCalendar } from "react-icons/fi";

const WelcomePage = () => {
  const currentTime = new Date().getHours();
  let greeting = "Good evening";
  if (currentTime < 12) greeting = "Good morning";
  else if (currentTime < 18) greeting = "Good afternoon";

  return (
    <div className="flex-1 p-6 lg:p-10 bg-gray-50 font-[Poppins] min-h-full">
      <div className="max-w-7xl mx-auto space-y-8">
        
        {/* Header Section */}
        <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 flex flex-col md:flex-row items-center justify-between gap-6 relative overflow-hidden">
          <div className="absolute right-0 top-0 w-64 h-64 bg-gradient-to-br from-[#FCC90D]/20 to-[#E52C31]/10 rounded-full blur-3xl -mr-20 -mt-20 pointer-events-none"></div>
          <div className="relative z-10 text-center md:text-left">
            <h1 className="text-4xl font-bold text-gray-900 mb-2">
              {greeting}, Welcome to <span className="text-[#E52C31]">MAAC</span>
            </h1>
            <p className="text-gray-500 text-lg">
              Here you can manage all aspects of the application, review reports, and make administrative changes.
            </p>
          </div>
          <div className="relative z-10 hidden md:block">
            <div className="bg-gradient-to-br from-[#E52C31] to-[#FCC90D] w-16 h-16 rounded-2xl flex items-center justify-center shadow-lg shadow-[#E52C31]/30 text-white transform rotate-3">
              <FiActivity size={32} />
            </div>
          </div>
        </div>

        {/* Quick Links / Status Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow group cursor-pointer">
            <div className="w-12 h-12 bg-blue-50 text-blue-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              <FiUsers size={24} />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">User Management</h3>
            <p className="text-gray-500 text-sm">Oversee centers, employees, and roles across the network.</p>
          </div>
          
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow group cursor-pointer">
            <div className="w-12 h-12 bg-[#FCC90D]/10 text-[#FCC90D] rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              <FiCalendar size={24} />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Events & Batches</h3>
            <p className="text-gray-500 text-sm">Schedule and manage upcoming events, tickets, and courses.</p>
          </div>

          <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow group cursor-pointer">
            <div className="w-12 h-12 bg-[#E52C31]/10 text-[#E52C31] rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              <FiSettings size={24} />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">System Settings</h3>
            <p className="text-gray-500 text-sm">Configure global settings, integrations, and administrative options.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
